export const SET_PAGES = 'viewer/pages/SET_PAGES';
export const SET_PAGINATION = 'pages/SET_PAGINATION';
export const SET_QUIZ_VALUE = 'pages/SET_QUIZ_VALUE';
export const SET_QUIZ_OPTION = 'pages/SET_QUIZ_OPTION';
export const SET_PAGE_LIST = 'viewer/pages/SET_PAGE_LIST';
export const SET_SELECT_OPTIONS = 'pages/SET_SELECT_OPTIONS';
export const RESET_SELECT_OPTIONS = 'pages/RESET_SELECT_OPTIONS';
export const SET_WRONG_PAGE_LIST = 'viewer/pages/SET_WRONG_PAGE_LIST';
export const RESET_WRONG_PAGE_LIST = 'viewer/pages/RESET_WRONG_PAGE_LIST';
export const RESET_ENTERED_VALUE = 'pages/RESET_ENTERED_VALUE';
export const RESET_QUIZ_START_TIME = 'pages/RESET_QUIZ_START_TIME';

